export const enum RecoilKeys {
  currentBreadcrumb = 'currentBreadcrumb',
  locale = 'locale',
  translate = 'translate',
}
